import { render, staticRenderFns } from "./GameBoardView.vue?vue&type=template&id=3ecf8e4a&scoped=true&"
import script from "./GameBoardView.vue?vue&type=script&lang=js&"
export * from "./GameBoardView.vue?vue&type=script&lang=js&"
import style0 from "./GameBoardView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameBoardView.vue?vue&type=style&index=1&id=3ecf8e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecf8e4a",
  null
  
)

export default component.exports